module.exports = __webpack_public_path__ + "static/dashboard-1ef5545e1dac0f02c031c5002ff28d25.png";